export class SchoolLviUrl {

    constructor(
        public url: string,
        public id?: number
    ){}
}
